import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { CloseIcon } from '../../../src/utils/SVG';
import WhiteReminderBell from '../../images/icons/whiteremindersbell.svg';
import ReminderStart from './components/startComponent/reminderStart';
import ReminderForm from './components/formComponent/reminderForm';
import ReminderReview from './components/reviewComponent/reminderReview';
import ReminderSuccess from './components/successComponent/reminderSuccess';
import './index.less';

// Forms
// 'START'   - Ask the user if they wanna receive notifications or not
// 'FORM'    - User wants notifications, ask for info on insurance
// 'REVIEW'  - Show user review or option to go back and edit
// 'SUCCESS' - Show user everything was successful

export default function Reminder() {
  const history = useHistory()
  const [stage, setStage] = useState('START');
  // Always start with 1 empty reminder
  const [reminders, setReminders] = useState([{
      insuranceType: null,
      insurer: null,
      renewalMonth: null,
      annualPayment: null,
      errors: {}
  }]);

  function exitFunc() {
    return history.push('/seguros');
  }

  return(
    <div className="reminder-component">
      <div className="reminder-header">
        <img width={20} height={20} src={WhiteReminderBell}/>
        <span>Lembretes</span>
        <div className="reminder-close" onClick={exitFunc}>
          <CloseIcon
            fill="white"
          />
        </div>
      </div>
      
      <div className={`reminder-body ${_.toLower(stage)}`} key={stage}>
        {stage === 'START' && 
          <ReminderStart
            setStage={setStage}
            exitFunc={exitFunc}
          />
        }
        {stage === 'FORM' && 
          <ReminderForm
            setStage={setStage}
            reminders={reminders}
            setReminders={setReminders}
          />
        }
        {stage === 'REVIEW' &&
          <ReminderReview
            setStage={setStage}
            reminders={reminders}
          />
        }
        {stage === 'SUCCESS' &&
          <ReminderSuccess
            exitFunc={exitFunc}
            reminders={reminders}
          />
        }
      </div>
    </div>
  );
}